import React from 'react';

// Components
import OrderTotals from '../../../../../components/orderTotals';

// Hooks
import useCart from '../../../../../hooks/orders/CartProvider';

const TotalsView = () => {
    const { sale } = useCart();
    
    return (
        <OrderTotals
            order={sale}
            totalPayedAmount={sale.totalPayedAmount}
        />
    )
}

export default TotalsView;